import React, { FC } from 'react';
import { Badge } from 'reactstrap';
import { ProductCategoryModel } from '../../../../shared/orders/product';
import { useTranslation } from '../../../translations';

interface CategoryBadgesProps {
  readonly category: ProductCategoryModel;
}

export const CategoryBadges: FC<CategoryBadgesProps> = ({ category }) => {
  const { ts } = useTranslation();

  let categoryType = 'Digital Products';
  if (category.isRegistration) {
    categoryType = 'Registration Products';
  } else if (category.isVendor) {
    categoryType = 'Vendor Products';
  } else if (!category.isDigital) {
    categoryType = 'Physical Products';
  }

  return (
    <div className="badge-list compact">
      {category.isStore && (
        <Badge color="success" id="visibleEventStore" pill>
          {ts('visible_in')} {ts('event_store')}
        </Badge>
      )}
      <Badge color="secondary" pill>
        {categoryType}
      </Badge>
    </div>
  );
};
